module.exports = __webpack_public_path__ + "static/img/kyxm.5f30c882.png";